import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft, Loader2, Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { invoiceService } from '@/services';

export default function InvoiceWithQuoteBasis() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: invoice, isLoading } = useQuery({
    queryKey: ['invoice', id],
    queryFn: async () => {
      const result = await invoiceService.getWithVendor(id!);
      if (result.error) throw result.error;
      return result.data;
    },
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[50vh]">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground mb-4">Invoice not found.</p>
        <Button variant="outline" onClick={() => navigate('/invoices')}>
          Back to Invoices
        </Button>
      </div>
    );
  }

  return (
    <div className="animate-slide-up">
      {/* Back button + Edit */}
      <div className="flex items-center justify-between mb-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/invoices')}
          className="-ml-2"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Invoices
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate(`/invoices/${id}/edit`)}
        >
          <Pencil className="w-4 h-4 mr-1" />
          Edit
        </Button>
      </div>

      {/* Placeholder content */}
      <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-12 text-center">
        <h2 className="text-lg font-semibold mb-2">
          Invoice (Quote Basis) — {invoice.invoice_number || id?.slice(0, 8)}
        </h2>
        <p className="text-muted-foreground">
          This page will display the quote-basis invoice detail view. Content coming soon.
        </p>
      </div>
    </div>
  );
}
